import styles from "./BidPanel.module.css";
import logo from "../../images/logo.svg";
import bid from "../../images/bid.svg";
import db from "../../firebase";
import { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { TimeSvg } from "../Common";
import { v4 } from "uuid";
import {
  collection,
  getDocs,
  query,
  doc,
  setDoc,
  where,
  updateDoc,
  Timestamp,
  increment,
} from "firebase/firestore";
import {
  stopBidding,
  updateActiveCelebData,
  updateUserWallet,
} from "../../store/actions";

const BidPanel = () => {
  const panelOuterRef = useRef();
  const dispatch = useDispatch();
  const bidPanel = useSelector((state) => state.bidPanel);

  const userId = bidPanel.userId;
  const imageId = bidPanel.imageId;
  const celebId = bidPanel.celebId;

  const [wallet, setWallet] = useState();
  const [timeLeft, setTimeLeft] = useState();
  const [highestBid, setHighestBid] = useState();
  const [bidAmount, setBidAmount] = useState();
  const [liveTime, setLiveTime] = useState();
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [highestBidBy, setHighestBidBy] = useState();

  const activeCelebData = useSelector((state) => state.activeCelebData);
  const activeImage = useSelector((state) => state.activeImage);

  useEffect(() => {
    const getWallet = async () =>
      await getDocs(
        query(collection(db, "user_data"), where("uid", "==", userId))
      ).then((docs) =>
        docs.forEach((doc) => {
          setWallet(doc.data().wallet);
        })
      );

    const getImagedata = async () =>
      await getDocs(
        query(
          collection(db, `biddify/${celebId}/gallery`),
          where("id", "==", imageId)
        )
      ).then((docs) =>
        docs.forEach((doc) => {
          setTimeLeft(doc.data().timeLeft.seconds);
          setHighestBid(doc.data().highestBid);
        })
      );

    const getHighestBidBy = async () =>
      await getDocs(
        query(
          collection(db, `biddings`),
          where("imageId", "==", imageId),
          where("celebId", "==", celebId),
          where("status", "==", "won")
        )
      ).then((docs) => {
        if (docs.docs.length === 0) {
          setHighestBidBy("No one");
        } else {
          setHighestBidBy(docs.docs[0].data().uid);
        }
      });

    getWallet();
    getImagedata();
    getHighestBidBy();
  }, [userId, celebId, imageId]);

  if (timeLeft) {
    setInterval(() => {
      setLiveTime(
        timeLeft - Timestamp.fromDate(new Date()).seconds > 0
          ? timeLeft - Timestamp.fromDate(new Date()).seconds
          : 0
      );
    }, 1000);
  }

  function timeFormat(seconds) {
    var secondss = parseInt(seconds);
    var days = Math.floor(secondss / (3600 * 24));
    secondss -= days * 3600 * 24;
    var hrs = Math.floor(secondss / 3600);
    secondss -= hrs * 3600;
    var mnts = Math.floor(secondss / 60);
    secondss -= mnts * 60;
    return days + ":" + hrs + ":" + mnts + ":" + secondss;
  }

  const bidFn = () => {
    // validation
    if (bidAmount === undefined) {
      alert("Please enter a bid amount.");
      return;
    }

    if (bidAmount > wallet) {
      alert("Not enough amount in wallet.");
      return;
    }

    if (highestBid === bidAmount || bidAmount < highestBid) {
      alert("Your bid should be higher than highest bid.");
      return;
    }

    if (liveTime === 0) {
      alert("Time Expired");
      return;
    }
    
    if (agreeTerms === false) {
      alert("Please accept our terms.");
      return;
    }

    // add biddings transaction
    const randNumber1 = v4();
    setDoc(doc(db, "biddings", randNumber1), {
      bid_amount: bidAmount,
      celebId: celebId,
      id: randNumber1,
      imageId: imageId,
      previous_bid_amount: highestBid,
      time: Timestamp.now(),
      uid: userId,
      type: "bid",
      status: "won",
      notified: false,
    });

    // add user transaction
    const randNumber2 = v4();
    setDoc(doc(db, `user_data/${userId}/transactions`, randNumber2), {
      amount: -bidAmount,
      id: randNumber2,
      time: Timestamp.now(),
      type: "bid",
    });

    // update user wallet
    updateDoc(doc(db, "user_data", userId), {
      wallet: wallet - bidAmount,
    });

    // set new bidding amount (server)
    updateDoc(doc(db, `biddify/${celebId}/gallery`, imageId), {
      highestBid: bidAmount,
    });

    // set new bidding amount (local)
    let tempData = activeCelebData.map((item, index) => {
      if (index === activeImage) {
        const tempp = item;
        tempp.highestBid = bidAmount;
        return tempp;
      } else {
        return item;
      }
    });
    dispatch(updateActiveCelebData(tempData));

    // return last bid
    const returnBiddings = async () =>
      await getDocs(
        query(
          collection(db, "biddings"),
          where("imageId", "==", imageId),
          where("celebId", "==", celebId)
        )
      ).then((bids) => {
        const bidss = bids.docs.filter(
          (item) =>
            item.data().id !== randNumber1 &&
            item.data().type !== "revert" &&
            item.data().status !== "adjusted"
        );

        bidss.forEach((bid) => {
          const bidData = bid.data();

          updateDoc(doc(db, "user_data", bidData.uid), {
            wallet: increment(bidData.bid_amount),
          });

          updateDoc(doc(db, "biddings", bidData.id), {
            status: "adjusted",
          });

          const randNumber3 = v4();
          setDoc(doc(db, "biddings", randNumber3), {
            bid_amount: -bidData.bid_amount,
            celebId: bidData.celebId,
            id: randNumber3,
            imageId: bidData.imageId,
            previous_bid_amount: bidData.previous_bid_amount,
            time: Timestamp.now(),
            uid: bidData.uid,
            type: "revert",
          });

          const randNumber4 = v4();
          setDoc(
            doc(db, `user_data/${bidData.uid}/transactions`, randNumber4),
            {
              amount: bidData.bid_amount,
              id: randNumber4,
              time: Timestamp.now(),
              type: "revert",
            }
          );

          const randNumber5 = v4();
          setDoc(
            doc(db, `user_data/${bidData.uid}/notifications`, randNumber5),
            {
              id: randNumber5,
              msg: `Your bid is not the highest now, refunded $${bidData.bid_amount}`,
              time: Timestamp.now(),
              read_status: false,
            }
          );
        });
      });
    returnBiddings();

    // update local states
    setWallet(wallet - bidAmount);
    dispatch(updateUserWallet(wallet - bidAmount));
    setBidAmount(undefined);
    setAgreeTerms(false);
    dispatch(stopBidding());
    alert("Bid Done");
  };

  const closePanel = (e) => {
    if (e.target.classList[0] !== panelOuterRef.current.className) {
      return;
    }
    dispatch(stopBidding());
  };

  return (
    <section className={styles.outer} onClick={closePanel} ref={panelOuterRef}>
      <div className={styles.inner}>
        <div className="text-center py-2">
          <img src={logo} className={styles.logo} alt="img" />
        </div>
        <hr className={styles.hrLine} />
        <div className={styles.timeBar}>
          <TimeSvg />
          <span className="ms-1">{liveTime && timeFormat(liveTime)} Left</span>
        </div>
        <div className={styles.middleSection}>
          <div>
            <p className={styles.balanceBar}>Balance: ${wallet}</p>
            <div className={styles.searchBar}>
              <div className={styles.dropDown}>Wallet</div>
              <input
                type="text"
                className={styles.priceInput}
                placeholder="Enter your bid"
                value={bidAmount === undefined ? "" : bidAmount}
                onChange={(e) =>
                  e.target.value
                    ? setBidAmount(parseFloat(e.target.value))
                    : setBidAmount(undefined)
                }
              />
              <div className={styles.amount}>
                <span className={styles.amountLable}>Highest Bid</span>
                <p className={styles.amountPrice}>${highestBid}</p>
              </div>
            </div>
            <div className="text-center mt-5">
              Current Highest bid is by:
              {highestBidBy && (
                <p>{highestBidBy === userId ? "You" : highestBidBy}</p>
              )}
            </div>
          </div>
          <div className="text-center">
            <button className={styles.button} onClick={() => bidFn()}>
              BUY NOW
              <img src={bid} alt="Buy Icon" className={styles.bidNowIcon} />
            </button>
            <p className={styles.disclaimer}>
              <input
                type="checkbox"
                className={styles.checkboxx}
                checked={agreeTerms}
                onChange={(e) => setAgreeTerms(e.target.checked)}
              />
              I agree to{" "}
              <a href="/terms" className={styles.link}>
                Terms of Service
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BidPanel;
